// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import RouteChecklistController from './route_checklist_controller'
import PlacesController from './places_controller'
import FeatherController from './feather_controller'
import TooltipController from './tooltip_controller'
import PopoverController from './popover_controller'
import ToastController from './toast_controller'
import PostalCodesInputController from './postal_codes_input_controller'
import SidebarToggleController from './sidebar_toggle_controller'
import PhoneNumberInputController from './phone_number_input_controller'
import PrintController from './print_controller'
import DrawingController from './drawing_controller'
import SignatureController from './signature_controller'

application.register('route-checklist', RouteChecklistController)
application.register('places', PlacesController)
application.register('feather', FeatherController)
application.register('tooltip', TooltipController)
application.register('popover', PopoverController)
application.register('toast', ToastController)
application.register('postal-codes-input', PostalCodesInputController)
application.register('sidebar-toggle', SidebarToggleController)
application.register('phone-number-input', PhoneNumberInputController)
application.register('print', PrintController)
application.register('drawing', DrawingController)
application.register('signature', SignatureController)
